// extracted by mini-css-extract-plugin
export default {"innerWrapper":"jw-z","tooltipWrapper":"kw-z","icon":"lw-z","tooltip":"mw-z","content":"nw-z"};